import { Injectable } from '@angular/core';
import { FormGroup, ValidatorFn } from '@angular/forms';

@Injectable()
export class FormService {

  constructor() { }

  setFieldVisibility(form: FormGroup, fields: string[], action: 'enable' | 'disable') {
    if (fields?.length) {
      fields?.forEach((field) => {
        form?.get(field)?.[action]();
      });
    }
  }

  setVisibility(form: FormGroup, action: 'enable' | 'disable') {    
    form?.[action]();
  }

  setFieldDirtyOrPristine(form: FormGroup, formControlName: string, status: boolean) {
    if (form && formControlName) {
      status ? form?.get(formControlName)?.markAsDirty() : form?.get(formControlName)?.markAsPristine();
    }
  }

  setFieldsDirtyOrPristine(form: FormGroup, fields: string[], status: boolean) {
    if (form && fields?.length) {
      fields?.forEach((field) => {
        status ? form?.get(field)?.markAsDirty() : form?.get(field)?.markAsPristine();
      });
    }
  }

  setAllFieldDirtyOrPristine(form: FormGroup, isDirty: boolean = false) {
    Object.values(form?.controls)?.forEach(control => {
      isDirty ? control?.markAsDirty() : (control?.value ? control?.markAsDirty() : control?.markAsPristine());
      if ((control as FormGroup)?.controls) {
        this.setAllFieldDirtyOrPristine(control as FormGroup, isDirty);
      }
    });
  }

  setFormValues(form: FormGroup, fieldValueGroup: {[s: string]: any}) {
    form.patchValue(fieldValueGroup);
    this.setFieldsDirtyOrPristine(form, Object.keys(fieldValueGroup), true);
  }

  resetForm(form: FormGroup) {    
    form?.reset();
  }

  manageValidatorByValue(form: FormGroup, formControlName: string, valueStatus: boolean, validators: ValidatorFn | ValidatorFn[]) {
    valueStatus
      ? form?.get(formControlName)?.clearValidators()
      : form?.get(formControlName)?.setValidators(validators);
    form?.get(formControlName)?.updateValueAndValidity();
  }

  setAllAsTouched(form: FormGroup) {
    form.markAllAsTouched();
  }

  updateFormValueAndValidity(form: FormGroup) {
    form?.updateValueAndValidity();
  }
}
